module.exports = __webpack_public_path__ + "static/media/Depositphotos_99045402_xl-2015.59162906.jpg";